var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "card-left"
  }, [_c("img", {
    attrs: {
      src: _vm.img,
      alt: "image"
    }
  })]), _c("div", {
    staticClass: "card-right"
  }, [_c("h4", [_vm._v(_vm._s(_vm.title))]), _c("p", [_vm._v(_vm._s(_vm.desc))])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };